import { render, staticRenderFns } from "./DropdownPlayground.vue?vue&type=template&id=0423c8f2&scoped=true&"
import script from "./DropdownPlayground.vue?vue&type=script&lang=js&"
export * from "./DropdownPlayground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0423c8f2",
  null
  
)

export default component.exports